import React, { useState } from 'react';
import './technologies.css';
import bgImage from '../../assets/bg.jpg';
import TechnologyCard from '../../components/TechnologyCard/TechnologyCard';
import BtnFilter from '../../components/btnFilter/BtnFilter';
import data from '../../technologies.json';

const Technologies = () => {
  const [currentTechnologies, setCurrentTechnologies] = useState(data);

  const categoryList = [
    'All',
    'Front End',
    'Back End',
    'Database',
    'Mobile',
    'Version Control',
    'Hosting',
    'Editing',
    'Others',
  ];

  const handleFilter = (category) => {
    let filteredTechnologies =
      category === 'All'
        ? data
        : data.filter((technology) => technology.category === category);

    setCurrentTechnologies(filteredTechnologies);
  };

  return (
    <>
      <main>
        <img src={bgImage} alt="bgImage" className="bgImage" />
        <div className="filterContainer">
          {categoryList.map((category) => (
            <div key={category} onClick={() => handleFilter(category)}>
              <BtnFilter name={category} />
            </div>
          ))}
        </div>
        <div className="technologyContainer">
          {currentTechnologies.map((technology) => (
            <TechnologyCard key={technology.id} technology={technology} />
          ))}
        </div>
      </main>
    </>
  );
};

export default Technologies;
